<!-- Responsibility: Implement sys section help display behavior for the ui/panels surface.
Scope: Owns ui/panels concerns only; cross-surface orchestration is excluded. -->
<sys-section-help-display>
  <div>
    <h5 if={ !props.view?.devOnly } class="section-title" style="margin-top:var(--space-lg);">HELP</h5>
    <button if={ !props.view?.devOnly } class="action-btn" style="margin-bottom:var(--space-lg);" onclick={ () => props.actions?.openHowToPlay?.() }>? HOW TO PLAY</button>

    <h5 if={ !props.view?.devOnly } class="section-title">DISPLAY</h5>
    <button if={ !props.view?.devOnly } class="action-btn" style="margin-bottom:var(--space-xs);" onclick={ () => props.actions?.toggleDim?.() }>
      { props.view?.isDim ? '☀ STANDARD MODE' : '☾ DIM MODE' }
    </button>
    <button if={ !props.view?.devOnly } class="action-btn" onclick={ () => props.actions?.openGallery?.() }>⊞ VISION GALLERY</button>
  </div>
</sys-section-help-display>
